import { PRICING } from '../constants/formConfig';

export function getStudentTestPrice() {
  return PRICING.studentFee;
}

/** A row counts as an entered student once any of its fields has data. */
export function isStudentEntered(student) {
  return Boolean(
    student?.firstName?.trim() ||
      student?.lastName?.trim() ||
      student?.gradeLevel ||
      student?.tests?.reasoning ||
      student?.tests?.computation,
  );
}

export function countEnteredStudents(students = []) {
  return students.filter(isStudentEntered).length;
}

export function countSelectedTests(student) {
  if (!student?.tests) return 0;
  return Number(!!student.tests.reasoning) + Number(!!student.tests.computation);
}

export function getStudentPrice(student) {
  return countSelectedTests(student) * getStudentTestPrice();
}

export function calculateTotals(students = []) {
  const studentFees = students.reduce(
    (sum, student) => sum + getStudentPrice(student),
    0,
  );

  return {
    studentCount: countEnteredStudents(students),
    testCount: students.reduce(
      (sum, student) => sum + countSelectedTests(student),
      0,
    ),
    studentFees,
    total: studentFees,
    perTest: getStudentTestPrice(),
  };
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount || 0);
}
